export class SensorSortState {
  public id: string;
  public name: string;
  public number: number;
  public originalModule: string;
  public moduleSerial: string;
  public data: string;
}
